/**
 * Command-palette context + hook (issue #1440).
 *
 * Split out of GlobalSearchProvider.tsx so the .tsx module exports ONLY the
 * provider component (keeps React Fast Refresh + the
 * `react-refresh/only-export-components` lint rule clean -- the same pattern as
 * contexts/auth.ts vs AuthContext.tsx).
 */
import { createContext, useContext } from "react";

export interface GlobalSearchContextValue {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export const GlobalSearchContext = createContext<
  GlobalSearchContextValue | undefined
>(undefined);

export function useGlobalSearch(): GlobalSearchContextValue {
  const ctx = useContext(GlobalSearchContext);
  if (!ctx) {
    throw new Error("useGlobalSearch must be used within a GlobalSearchProvider");
  }
  return ctx;
}
